import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";

import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import {
    checkIfExistBusiness,
    isInactiveSignalSubscription,
} from "helpers/getStarted/createBussinesApi";
import { getStartedData } from "helpers/getStarted/getStarted";

import BussinesModal from "components/BussinesModal";
import Facebook from "components/Facebook";
import SourcesModal from "components/SourcesModal";
import SwalAlertComp from "components/SwalAlert";

import { loginTrue } from "../../redux/slices/isLogin/isLogin.slice";
import "./WelcomePage.css";

const WelcomePage = () => {
    const [searchParams] = useSearchParams();
    const [show, setShow] = useState(false);
    const [showBussines, setShowBussines] = useState(false);
    const [facebookData, setFacebookData] = useState("");
    const [accesFBData, setAccesFBData] = useState("");
    const [createBussinesData, setCreateBussinesData] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [fbCode, setRedirectPage] = useState(searchParams.get("code"));
    const [showCreateSource, setShowCreateSource] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [inactiveSubscription, setInactiveSubscription] = useState(false);
    const [loginStatusAccesToken, setLoginStatusAccesToken] = useState("");

    const [tikTokData, setTikTokData] = useState("");
    const handleClose = () => setShow(false);

    const language = useSelector((state) => state.languagesState.languages);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        if (fbCode && facebookData) {
            (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            })(document, "script", "facebook-jssdk");

            window.fbAsyncInit = () => {
                window.FB.init({
                    appId: facebookData.app_id,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: facebookData.version,
                });
                window.FB.getLoginStatus(async function (response) {
                    if (response.status === "connected") {
                        setLoginStatusAccesToken(
                            response.authResponse.accessToken,
                        );
                        try {
                            let data = {
                                tokenDetail: {
                                    accessToken:
                                        response.authResponse.accessToken,
                                },
                            };
                            await updatedData(data);
                        } catch (error) {
                            console.error(
                                "Error handling login status:",
                                error,
                            );
                        }
                    }
                });
            };
        }
    }, [fbCode, facebookData]);

    useEffect(() => {
        const getStarted = async () => {
            let result = await getStartedData();
            if (result.status) {
                setFacebookData(
                    result.data && result.data.data && result.data.data,
                );
                //dispatch(setAppIdRedux(result?.data?.data?.facebook ?? ""))
                setTikTokData(
                    result.data && result.data.data && result.data.data,
                );
                setShow(true);
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: result.message && result.message,
                    icon: "error",
                });
            }
        };
        getStarted();
    }, []);

    const clickHandler = () => {
        window.localStorage.removeItem("swo");
        window.location.href =
            process.env.REACT_APP_CONSOLE_URL + "/dash/sso/signal";
    };
    const openSubscriptions = () => {
        window.localStorage.removeItem("swo");
        window.location.href =
            process.env.REACT_APP_CONSOLE_URL + "/dash/subscriptions";
    };
    const showInactiveSubscription = () => {
        setVerifying(false);
        setShow(false);
        setShowBussines(false);
        setShowCreateSource(false);
        setInactiveSubscription(true);
    };
    const clickHandlerReg = () => {
        window.localStorage.removeItem("swo");
        window.location.href =
            process.env.REACT_APP_CONSOLE_URL + "/dash/login?service=free";
    };
    const clickHandlerRES = () => {
        window.localStorage.removeItem("swo");
        window.location.href =
            process.env.REACT_APP_CONSOLE_URL + "/dash/password/reset";
    };
    const updatedModaShow = () => {
        setShow(false);
    };
    const updatedData = async (data) => {
        if (
            data &&
            data.tokenDetail &&
            data.tokenDetail.accessToken &&
            data.tokenDetail.accessToken
        ) {
            setVerifying(true);
            setInactiveSubscription(false);
            setAccessToken(
                data &&
                    data.tokenDetail &&
                    data.tokenDetail.accessToken &&
                    data.tokenDetail.accessToken,
            );
            let form = {
                access_token:
                    data &&
                    data.tokenDetail &&
                    data.tokenDetail.accessToken &&
                    data.tokenDetail.accessToken,
            };
            let result = await checkIfExistBusiness(form);
            setVerifying(false);
            if (isInactiveSignalSubscription(result)) {
                showInactiveSubscription();
                return;
            }
            if (result.status) {
                if (
                    result.data &&
                    result.data.is_onboarded &&
                    result.data.is_onboarded
                ) {
                    setCreateBussinesData(result.data);
                    if (result.data.has_tracker) {
                        window.localStorage.setItem(
                            "token",
                            result.data &&
                                result.data.auth_token &&
                                result.data.auth_token,
                        );
                        dispatch(loginTrue());
                        navigate("/trackers");
                        //Redirect to Trackers
                    } else {
                        setShow(false);
                        setShowBussines(false);
                        setShowCreateSource(true);
                    }
                } else {
                    setAccesFBData(data);
                    handleClose();
                    setShowBussines(true);
                }
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: result.message && result.message,
                    icon: "error",
                });
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message:
                    language?.welcomepage?.something_went_wrong ??
                    "Something went wrong. Please try again!",
                icon: "error",
            });
            handleClose();
        }
    };
    const updatedDataBussines = (data) => {
        setCreateBussinesData(data);
        setShowBussines(false);
        setShowCreateSource(true);
    };

    const handleClickStartWithOthers = () => {
        window.localStorage.setItem("swo", "true");
        window.location.href =
            process.env.REACT_APP_CONSOLE_URL + "/dash/sso/signal";
    };
    return (
        <Box height={"100vh"} display={"flex"} flexDirection={"column"}>
            <nav
                className="navbar navbar-expand-lg navbar-white bg-white max-w-7xl mx-auto pt-5 pb-6"
                style={{ width: "100%" }}
            >
                <div className="flex-none">
                    <a href="/login">
                        <img
                            src="/assets/images/image-removebg.png"
                            className="lg:ml-0 welcomePageSignalsightPicture"
                            alt="Signalsight Logo"
                            style={{ width: "250px" }}
                        />
                    </a>
                </div>
                <button
                    className="navbar-toggler welcomePageHamburgerButton"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="menu-button"
                        className="h-6 w-6 cursor-pointer block lg:hidden"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    </svg>
                </button>
                <div
                    className="collapse navbar-collapse justify-content-end welcomePageButtonGroup"
                    id="navbarNav"
                >
                    <ul className="navbar-nav">
                        <li className="nav-item active">
                            <a className="nav-link" target="_blank">
                                <button
                                    className="btn welcomePageButton welcomePageButtonLogin"
                                    onClick={clickHandler}
                                >
                                    {language?.buttons?.login ?? "Login"}
                                </button>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" target="_blank">
                                <button
                                    className="btn welcomePageButton welcomePageButtonRegister"
                                    onClick={clickHandlerReg}
                                >
                                    {language?.buttons?.register ?? "Register"}
                                </button>
                            </a>
                        </li>
                        {/* <li className="nav-item">
              <a className="nav-link" target="_blank">
                <button className="btn welcomePageButton welcomePageButtonForgot" onClick={clickHandlerRES}>
                  {language?.buttons?.forgot_password ?? "Forgot Password"}
                </button>
              </a>
            </li> */}
                    </ul>
                </div>
            </nav>
            <div
                className="relative flex flex-col-reverse max-w-7xl mx-auto pt-3 pb-14 text-dark
              lg:flex-row lg:gap-4 lg:mt-14 lg:pb-32"
                style={{ flex: 1 }}
            >
                <div className="basis-1/2 px-5 py-3 lg:p-0 welcome-explanation">
                    <h1 className="text-2.5xl leading-11 lg:text-4.5xl font-semibold lg:leading-12">
                        <span className="block">
                            {language?.welcomepage?.more_customer_signals ??
                                "More Customer Signals."}
                        </span>
                        <span className="block">
                            {language?.welcomepage?.greater_insight ??
                                "Greater Insight."}
                        </span>
                    </h1>
                    <h2 className="mt-1.5 lg:mt-3">
                        <span className="ring-2 ring-primary rounded-full -ml-2.5 px-3 lg:-ml-5 lg:px-5 text-2.5xl leading-11 lg:text-4.5xl font-semibold lg:leading-12">
                            {language?.welcomepage?.no_cookies_needed ??
                                "No Cookies Needed."}
                        </span>
                    </h2>
                    <p
                        className="mt-7 font-normal text-sm leading-7
                lg:mt-14 lg:text-lg lg:leading-9"
                    >
                        {language?.welcomepage?.join_the_platform ??
                            "Join SignalSight, the trusted choice of leading international brands for resillience customer signals to enhance their online performance."}
                    </p>
                </div>
                <div className="basis-1/2 h-full p-3 lg:p-0">
                    <div className="max-w-full lg:ml-10 h-80 rounded-3xl">
                        <div>
                            <h2 className="mb-3 right-side-header">
                                {language?.welcomepage?.the_better_your_data ??
                                    "The better your data, the better your ads ROI!"}
                            </h2>
                            {show && (
                                <p className=" right-side-paraghrapgh">
                                    {language?.welcomepage?.with_signalSight ??
                                        "With SignalSight, you don’t need to develop server side applications to integrate with Conversion API. No coding, no maintenance, and it’s super fast!"}
                                </p>
                            )}
                        </div>
                        {show && (
                            <div className="col-12 p-0">
                                <Facebook
                                    data={facebookData}
                                    updatedData={updatedData}
                                    updatedModaShow={updatedModaShow}
                                />
                                <Button
                                    className="btn btn-block mt-1 mb-3"
                                    variant="light"
                                    onClick={handleClickStartWithOthers}
                                >
                                    {language?.welcomepage
                                        ?.connect_other_options ??
                                        "Connect Other Options"}
                                </Button>
                            </div>
                        )}
                        {verifying && (
                            <div
                                className="d-flex align-items-center mt-3"
                                role="status"
                                aria-label="Loading"
                            >
                                <ClipLoader color="#3d50b7" size={28} />
                            </div>
                        )}
                        {inactiveSubscription && (
                            <div className="welcome-subscription-panel">
                                <p>
                                    {language?.welcomepage
                                        ?.subscription_not_active ??
                                        "Your subscription is not active."}
                                </p>
                                <div className="welcome-subscription-actions">
                                    <button
                                        type="button"
                                        className="btn welcomePageButton welcomePageButtonLogin"
                                        onClick={openSubscriptions}
                                    >
                                        {language?.welcomepage
                                            ?.renew_subscription ??
                                            "Renew subscription"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn welcomePageButton welcomePageButtonRegister"
                                        onClick={clickHandler}
                                    >
                                        {language?.welcomepage?.sign_in_again ??
                                            "Sign in again"}
                                    </button>
                                </div>
                            </div>
                        )}
                        {showBussines && (
                            <div className="col-12 p-1">
                                {" "}
                                <BussinesModal
                                    data={accesFBData}
                                    updatedDataBussines={updatedDataBussines}
                                />
                            </div>
                        )}
                        {showCreateSource && (
                            <div className="col-12 p-3">
                                {" "}
                                <SourcesModal
                                    data={createBussinesData}
                                    token={accessToken}
                                    loginStatusAccesToken={
                                        loginStatusAccesToken
                                    }
                                    onInactiveSubscription={
                                        showInactiveSubscription
                                    }
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="WelcomeFooter">
                <div className="bg-gray-100 pr-4 pl-3">
                    <div className="w-full lg:max-w-7xl mx-auto px-7 lg:px-0 grid grid-cols-12 py-10">
                        <div className="col-span-12 lg:col-span-3">
                            <img
                                src="/assets/images/image-removebg.png"
                                style={{ maxWidth: "250px" }}
                                alt="SignalSight"
                            />
                        </div>
                        <div className="col-span-12 lg:col-span-6">
                            <p className="mt-9 lg:mt-0 text-base font-semibold leading-6">
                                {language?.welcomepage?.about_signalSight ??
                                    "About SignalSight"}
                            </p>
                            <p className="text-sm lg:text-lg font-light leading-7 lg:leading-9">
                                {language?.welcomepage
                                    ?.signalsight_is_an_experienced ??
                                    "SignalSight is an experienced tech solution who strives"}
                                <br className="hidden lg:block" />
                                {language?.welcomepage
                                    ?.to_connect_brands_with_their ??
                                    "About SignalSight"}
                                to connect brands with their customers like
                                never before.
                            </p>
                        </div>
                        <div
                            className="col-span-12 lg:col-span-3 lg:block items-center"
                            style={{ marginTop: "5px" }}
                        >
                            <div className="col-span-12 lg:col-span-12 flex items-center gap-2">
                                <a
                                    href="https://www.facebook.com/business/partner-directory/search?solution_type=offline_conversion&ref=pd_home_hero_cta&id=4241777655899869&section=overview"
                                    target="_blank"
                                >
                                    <img
                                        src="/assets/images/meta_partner_badge.png"
                                        className="pr-1 welcomeFacebookPictures"
                                        style={{
                                            maxWidth: "140px",
                                            cursor: "pointer",
                                        }}
                                        alt="Meta Partner"
                                    />
                                </a>
                                <img
                                    src="/assets/images/tiktok.png"
                                    className="pr-1 welcomeTiktokPictures"
                                    style={{
                                        maxWidth: "140px",
                                        cursor: "pointer",
                                    }}
                                    alt="TikTok Partner"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default WelcomePage;
